import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const customBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_APIURL,
  prepareHeaders: (headers, { getState }) => {
    // console.log("getState", getState());
    const accessToken = localStorage.getItem("accessToken");
    const tokenZiyl = localStorage.getItem("token_ziyl");
    if (accessToken && tokenZiyl) {
      headers.set("Content-Type", "application/json");
      headers.set("AuthorizationFinxp", `Bearer ${accessToken}`);
      headers.set("Authorization", `Bearer ${tokenZiyl}`);
    }
    return headers;
  },
});

export const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await customBaseQuery(args, api, extraOptions);
  // Check if the session has expired
  if (result.error && result.error.status === 401) {
    if (result.error.data.errors[0] === "Invalid JWT") {
      // Check if the error is due to invalid JWT
      localStorage.removeItem("persist:root");
      localStorage.clear();
      window.location.href = "/app/login";
    }
  }
  return result;
};

export const accountV2 = createApi({
  reducerPath: "accountV2",
  baseQuery: baseQueryWithReauth,
  keepUnusedDataFor: 30,
  tagTypes: ["accountV2"],
  endpoints: (builder) => ({
    getAccount: builder.query({
      query: () => {
        return {
          url: `/ziyl/accountsfinxp`,
          method: "GET",
        };
      },
      invalidatesTags: ["accountV2"],
    }),
    getAccountDetails: builder.query({
      query: ({ accountId }) => ({
        url: `/ziyl/accountdetailsfinxp/${accountId}`,
      }),
      invalidatesTags: ["accountV2"],
    }),
    getAccountWithAuthenticatedToken: builder.query({
      query: ({ token_ziyl }) => {
        return {
          url: `/ziyl/accountsfinxp`,
          headers: {
            Authorization: `Bearer ${token_ziyl}`,
          },
          method: "GET",
        };
      },
      invalidatesTags: ["accountV2"],
    }),
  }),
});

export const {
  useGetAccountQuery,
  useLazyGetAccountQuery,
  useGetAccountDetailsQuery,
  useLazyGetAccountDetailsQuery,
  useLazyGetAccountWithAuthenticatedTokenQuery,
} = accountV2;
